import React from 'react'
import {
    Create,
    TextInput,
    BooleanInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin'

import { CustomSimpleForm } from '../Generic'

export const DatoTecnicoCreate = props => (
    <Create {...props}>
        <CustomSimpleForm>
            <TextInput source="name" label="Nombre" />
            <TextInput source="description" label="Descripción" />
            <BooleanInput source="active" label="Activo"/>
            <ReferenceInput source="datasheet_type" reference="esquemas-datos-tecnicos" label="Esquema">
                <SelectInput optionText="name"/>
            </ReferenceInput>
        </CustomSimpleForm>
    </Create>
);
